import React, { Component } from 'react';
import Autocomplete from '../Autocomplete';

class ProductTag extends Component {
  render() {
    return (
      <Autocomplete
        searchUrl="/api/v1/catalog/product/tags/autoComplete/"
        placeholder="Search Product Tags"
        onChange={this.props.onChange}
      />
    );
  }
}

export default ProductTag;
